module.exports = __webpack_public_path__ + "img/navigating-api-gateway.9c9ea834.jpg";